export enum MigrationType {
    Seperate = "Seperate"
}

export interface Migration {
    id: number;
    schoolId: number;
    type: MigrationType;
    stage: number;
    includeLogs: boolean;
    notBefore: Date;
    completed: Date;
    cancelled: boolean;
    complete: boolean;
}